module.exports = __webpack_public_path__ + "static/media/stubAvatar.f28c896e.svg";